import { ChakraProvider } from "@chakra-ui/react";
import { Routes, Route } from "react-router-dom";
import Layout from "./presentation/components/Layout";
import DefaultScreen from "./presentation/screens/DefaultFlow/DefaultScreen";
import { kStyleGlobal } from "./theme";
import { AboutUs } from "./presentation/components/AboutUs";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { ContactUs } from "./presentation/components/ContactUs";
import DemolitionServices from "./presentation/components/DemolitionServices";
import RenovationServices from "./presentation/components/RenovationServices";
import JanitorsServices from "./presentation/components/JanitorsServices";
import PostCleaning from "./presentation/components/PostCleaning";
import Manpower from "./presentation/components/Manpower";
import AdminContacts from "./presentation/components/Admin/AdminContacts";
import { HelmetProvider } from "react-helmet-async";
import DynamicTitle from "./presentation/components/DynamicTitle";
import ScrollToTop from "./presentation/components/ScrollToTop";

function App() {
  return (
    <ChakraProvider theme={kStyleGlobal}>
      <HelmetProvider>
        <DynamicTitle/>
        <ScrollToTop/>
      <Routes>
        {/* Public routes with Header/Footer */}
        <Route path="/" element={<Layout />}>
          <Route index element={<DefaultScreen />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="contact" element={<ContactUs />} />
          <Route path="services/demolition" element={<DemolitionServices />} />
          <Route path="services/renovation" element={<RenovationServices />} />
          <Route path="services/janitors" element={<JanitorsServices />} />
          <Route path="services/cleaning" element={<PostCleaning />} />
          <Route path="services/manpower" element={<Manpower />} />
        </Route>

        {/* Admin route WITHOUT Header/Footer */}
        <Route path="/adminContact" element={<AdminContacts />} />
      </Routes>
      
</HelmetProvider>
    </ChakraProvider>
  );
}

export default App;
